import styled from "styled-components";
import CardHeader from "./CardHeader";
import ScoreGraph from "./ScoreGraph";
import { hw } from "features/homework/homeworkUi";

interface StudentScoreProps {
    studentUid: string;
}

const StudentScore = ({ studentUid }: StudentScoreProps) => {
    return (
        <Container>
            <CardHeader title="성적" />
            <ScoreGraph student={studentUid} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    min-height: 0;
    padding: 18px 20px;
    border-radius: 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    box-shadow: ${hw.shadow};
`;

export default StudentScore;
